// @ts-nocheck
import {
	clearContactProvidersData,
	clearToken,
	getStorage,
	STORAGE_TAG_TOKEN,
} from './StorageHelper';
import axios, { CancelTokenSource } from 'axios';
import { generateUniqueID } from '@src/helpers/Helpers';
import { store } from '@src/store';
import { RESTAURANT } from '@src/Constants';
import { LocalStorage } from '@src/storage/LocalStorage';
import { setCurrentUser, setPermissions } from '@src/store/reducers/currentUserReducer';
import {
	setAllCatalogs,
	setAllProductsMasterCatalog,
	setSupplierCatalog,
} from '@src/store/reducers/catalogReducer';
import { setAllOrders } from '@src/store/reducers/orderReducer';
import { setCart } from '@src/store/reducers/cartReducer';
import { setCart as setMarketplaceCart, setProduct } from '@src/store/reducers/marketPlaceReducer';
import { setBranches, setRestaurants } from '@src/store/reducers/branchReducer';
import { setAllUsers } from '@src/store/reducers/teamReducer';
import { setChats } from '@src/store/reducers/chatsReducer';
import { clearApiCache } from './serviceWorkerHelper';

export const generateCancelToken = (): CancelTokenSource => {
	return axios.CancelToken.source();
};

export const getBranch = () => {
	const branchId = store?.getState()?.restaurant?.value?.default?.id;
	const type = store?.getState()?.currentUser?.value?.type;
	return { branchId, type };
};

export const getRequestConfig = (
	id,
	params,
	cancelToken,
	responseType,
	timeout,
	isV2Token = false,
	data = null
) => {
	const requestConfig = {
		withCredentials: false,
		params,
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			//'X-Request-ID': generateUniqueID(),
		},
		cancelToken: cancelToken,
	};
	if (isV2Token) {
		requestConfig.headers.Authorization = 'Bearer ' + getStorage().getItem(STORAGE_TAG_TOKEN);
	}

	const { branchId, type } = getBranch();

	if (type?.toLowerCase() === RESTAURANT) {
		requestConfig.headers['x-restaurant-id'] = branchId || id;
	} else {
		requestConfig.headers['x-supplier-id'] = branchId || id;
	}

	if (data) {
		requestConfig.data = data;
	}
	if (responseType !== undefined) {
		requestConfig.responseType = responseType;
	}

	if (timeout !== undefined) {
		requestConfig.timeout = timeout;
	}

	return requestConfig;
};

export const handleIfUnauthorized = (error, navigate) => {
	if (error?.response?.status === 401) {
		clearUserSession('invalidToken', undefined, navigate, () => apiService.logoutCallV2());
	}
};

export const clearPersistedData = () => {
	const localStorage = new LocalStorage();
	localStorage.removeItem('persist:root');
	store?.dispatch(setCurrentUser({}));
	store?.dispatch(setSupplierCatalog({}));
	store?.dispatch(setAllCatalogs([]));
	store?.dispatch(setAllProductsMasterCatalog([]));
	store?.dispatch(setAllOrders({}));
	store?.dispatch(setCart({}));
	store?.dispatch(setRestaurants({}));
	store?.dispatch(setAllUsers([]));
	store?.dispatch(setBranches([]));
	store?.dispatch(setPermissions([]));
	store?.dispatch(setChats({}));
	store?.dispatch(setMarketplaceCart([]));
	store?.dispatch(setProduct(null));
};

const setApplicationPathBeforeTokenGotExpire = () => {
	const localStorage = new LocalStorage();
	const prevPathData = {
		path: window.location.pathname + window.location.search,
		branchId: window.location.pathname.split('/')?.[2],
	};
	const prevPathJSON = JSON.stringify(prevPathData);
	localStorage.setItem('prevPath', prevPathJSON);
};

export const clearUserSession = (errorCase, nextLocation, navigate, logout) => {
	logout();
	clearToken();
	clearContactProvidersData();
	clearPersistedData();
	setApplicationPathBeforeTokenGotExpire();
	clearApiCache();

	let path;

	if (errorCase) {
		path = `/login/error/${errorCase}`;
	} else {
		path = '/';
	}

	if (navigate !== undefined) {
		navigate(path, {
			state: {
				nextPath: nextLocation?.pathname,
				search: nextLocation?.search,
			},
		});
	}
};

export enum HTTP_TYPES {
	GET = 'get',
	POST = 'post',
	DELETE = 'delete',
	PATCH = 'patch',
}
